import axios from "../api/axiosClient";

export function getExcelReports(exportType, successCallback, errorCallback) {
  axios
    .get(`/excelreports/${exportType}`)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function getExcelReportFieldSets(
  report,
  successCallback,
  errorCallback
) {
  axios
    .get(`/excelreports/${report}/fieldset`)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function runReportDownload(
  idExcelReport,
  params,
  successCallback,
  errorCallback
) {
  var url = `/excelreports/${idExcelReport}/excel`;

  let config = {};
  config.headers = { "Content-Type": "application/json" };
  axios
    .post(url, params)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}
